export default __webpack_public_path__ + "imgs/bcb8497528f043fc221a90f9fbe7cd15.png";